function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomPanoramicViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.456 13.635L3 19.69V10h26v10.172l-6.562-4.203a3 3 0 00-3.596.27l-1.54 1.351-3.611-3.826a3 3 0 00-4.235-.13zm6.341 5.275l-3.56-3.774a1 1 0 00-1.412-.042L3.462 22h24.684l-6.787-4.347a1 1 0 00-1.198.09l-4.002 3.509-1.318-1.504.956-.838zM1 9a1 1 0 011-1h28a1 1 0 011 1v14a1 1 0 01-1 1H2a1 1 0 01-1-1V9zm24 4.5a.5.5 0 11-1 0 .5.5 0 011 0zm2 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: props.color
  }));
}

export default SvgIconRoomPanoramicViewFilled;